import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=3c8ba5d0&scoped=true&"
import script from "./alarm.vue?vue&type=script&lang=js&"
export * from "./alarm.vue?vue&type=script&lang=js&"
import style0 from "./alarm.vue?vue&type=style&index=0&id=3c8ba5d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8ba5d0",
  null
  
)

export default component.exports